<div class="item" *ngFor="let item of content">
  <div class="menu-item{{ option.class ? ' ' + option.class : '' }}" *ngFor="let option of item.options"
    (click)="optionClick(option)">
    <div class="menu-separator" *ngIf="option.separator"></div>
    <bdr-icon class="menu-item-icon" *ngIf="option.icon" [icon]="option.icon"></bdr-icon>
    <span class="menu-item-caption" [ngClass]="{'link-item': !!option.action }">{{ option.caption }}</span>
  </div>
  <div class="version" *ngIf="item.version">Versión: {{item.version}}</div>
</div>